<template>
    <div class="sidebar sidebar-vertical sidebar-right">
        <div
                class="sidebar-backdrop"
                @click="toggleSidebarPanel"
                v-if="isPanelOpen"
        />
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'Sidebar',
        data() {
            return {
                isPanelOpen: true,
            };
        },
        mounted() {
            if (window.innerWidth < 991.98) {
                this.isPanelOpen = false;
            } else {
                this.isPanelOpen = true;
                this.$el.classList.add('sidebar-open');
            }
            window.addEventListener('resize', this.onResize);
            this.$uiBus.$on('TOGGLE_SIDEBAR', () => {
                this.toggleSidebarPanel();
            });
        },
        methods: {
            toggleSidebarPanel() {
                this.isPanelOpen = !this.isPanelOpen;

                if (this.isPanelOpen && !this.$root.$el.classList.contains('menu-open')) {
                    this.$root.$el.classList += '' + ' menu-open';
                    this.$el.classList.add('sidebar-open', 'animate');
                } else {
                    this.$root.$el.classList.remove('menu-open');
                    this.$el.classList.remove('sidebar-open');
                }

                this.$uiBus.$emit('ANIMATE_BURGER', this.isPanelOpen);
            },
            onResize() {
                if (window.innerWidth < 991.98) {
                    this.isPanelOpen = false;
                    this.$el.classList.remove('sidebar-open', 'animate');
                    if (this.$root.$el.classList.contains('menu-open') && !this.isPanelOpen) {
                        this.$root.$el.classList.remove('menu-open');
                    }
                } else {
                    this.isPanelOpen = true;
                    this.$el.classList.add('sidebar-open');
                }
                this.$uiBus.$emit('ANIMATE_BURGER', this.isPanelOpen);
            },
        },
    };
</script>

<style
        scoped
        lang="scss"
>
    .animate {
        -webkit-transition: all 0.3s ease;
        -moz-transition:    all 0.3s ease;
        transition:         all 0.3s ease;
    }

    .sidebar-backdrop {
        -webkit-transition: all 5s ease;
        -moz-transition:    all 5s ease;
        transition:         all 5s ease;
    }

    .sidebar-right {
        right: -270px;
    }

    .sidebar-vertical {
        width:   270px;
        height:  100%;
        top:     0;
        z-index: 1000;
    }

    .sidebar {
        position: fixed;
    }

    .sidebar-right.sidebar-open {
        right: 0;
    }

    @media (min-width: 991.98px) {
        .sidebar-right.sidebar-open {
            left: 0;
        }
    }

    .sidebar-backdrop {
        background-color: rgba(0, 0, 0, 0.5);
        min-width:        100vw;
        min-height:       100vh;
        height:           100%;
        position:         absolute;
        z-index:          -5;
        top:              0;
        left:             -100vw;
        cursor:           pointer;
        right:            0;
    }

    @media (min-width: 991.98px) {
        .sidebar-backdrop {
            display: none;
        }
    }
</style>
